module.exports = __webpack_public_path__ + "static/media/icon_web.6d3e1c52.svg";